import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import SearchableDropdown from "../../../../Core/Fields/Floating/SearchableDropdown";
import GetIcon from "../../../../utils/Icon";
const Tab2Table2 = ({
	setselected_auto_re_order_item_data,
	list_warehouse_check_in_data,
	list_warehouse_request_data,
	search_warehouse_data,
	list_material_request_type,
	setRows3,
	rows3,
}) => {
	const createNewRow = () => ({
		warehouse_group: "",
		warehouse: "",
		warehouse_reorder_level: "",
		warehouse_reorder_qty: "",
		material_request_type: "",
	});

	const tableRef = useRef();
	const dropdownRef = useRef(null);
	const dropdownRef1 = useRef(null);
	const [rowsPerPage] = useState(10);
	// For "warehouse" dropdown
	const [offset, setOffset] = useState(0);
	const [search_input, setsearch_input] = useState("");

	// For "warehouse_request" dropdown
	const [offset1, setOffset1] = useState(0);
	const [search_input1, setsearch_input1] = useState("");

	// Pagination control (optional but required if used)
	const [hasMore, setHasMore] = useState(true); // for warehouse
	const [hasMoreCategory, setHasMoreCategory] = useState(true); // for warehouse_request

	const [warehouse_list, setwarehouse_list] = useState([]);
	const [warehouse_request_list, setwarehouse_request_list] = useState([]);
	const [material_request_type_list, setmaterial_request_type_list] = useState(
		[]
	);
	const [currentPage, setCurrentPage] = useState(1);
	// const [rows, setRows3] = useState([createNewRow()]);
	const [selectedRows, setSelectedRows] = useState([]);
	// const [search_input, setsearch_input] = useState("");
	const [focusedCell, setFocusedCell] = useState({
		rowIndex: null,
		field: null,
	});
	const [showDropdown, setShowDropdown] = useState({
		rowIndex: null,
		field: null,
	});
	const isAllSelected =
		rows3.length > 0 && selectedRows.length === rows3.length;
	const indexOfLastRow = currentPage * rowsPerPage;
	const indexOfFirstRow = indexOfLastRow - rowsPerPage;
	const currentRows = rows3.slice(indexOfFirstRow, indexOfLastRow);

	const handleSelectAll = (e) => {
		if (e.target.checked) {
			const allRowIndices = rows3.map((_, index) => index);
			setSelectedRows(allRowIndices);
		} else {
			setSelectedRows([]);
		}
	};

	const getmaterial_request_type_list = async () => {
		const response = await list_material_request_type(); // Call it like an API
		setmaterial_request_type_list(response); // Save to state
	};

	const getwarehouse_data = async (newOffset = 0, searchText = "") => {
		const res = await search_warehouse_data({
			start: newOffset,
			search_input: searchText,
		});
		const products = res?.data?.data || [];
		// console.log('tax cat list:',products)
		if (newOffset === 0) {
			setwarehouse_list(products);
		} else {
			setwarehouse_list((prev) => [...prev, ...products]);
		}
		setHasMore(products.length === 20);
	};

	const getwarehouse_request_data = async (newOffset = 0, searchText = "") => {
		const res = await search_warehouse_data({
			start: newOffset,
			search_input: searchText,
		});
		const products = res?.data?.data || [];
		// console.log('tax cat list:',products)
		if (newOffset === 0) {
			setwarehouse_request_list(products);
		} else {
			setwarehouse_request_list((prev) => [...prev, ...products]);
		}
		setHasMore(products.length === 20);
	};
	// const updateRow = (index, field, value) => {
	//   const updatedRows = [...rows];
	//   updatedRows[index][field] = value;
	//   setRows3(updatedRows);
	//   setselected_auto_re_order_item_data(updatedRows)
	// };
	const updateRow = (index, field, value) => {
		const updatedRows = [...rows3];

		// Ensure item exists
		if (!updatedRows[index].item) {
			updatedRows[index].item = {};
		}

		updatedRows[index].item[field] = value;

		setRows3(updatedRows);
		setselected_auto_re_order_item_data(updatedRows);
	};

	const toggleRowSelection = (index) => {
		setSelectedRows((prev) =>
			prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
		);
	};

	const handleAddRow = () => {
		const newRows = [...rows3, createNewRow()];
		setRows3(newRows);
		setselected_auto_re_order_item_data(newRows);
		const lastPage = Math.ceil(newRows.length / rowsPerPage);
		if (currentPage !== lastPage) {
			setCurrentPage(lastPage);
		}
	};

	const handleDeleteSelectedRows = () => {
		const updatedRows = rows3.filter((_, idx) => !selectedRows.includes(idx));
		setRows3(updatedRows);
		setselected_auto_re_order_item_data(updatedRows);
		setSelectedRows([]);
		const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
		if (currentPage > lastPage) {
			setCurrentPage(lastPage);
		}
	};

	useEffect(() => {
		getmaterial_request_type_list(0, "");
		getwarehouse_data(0, "");
		getwarehouse_request_data(0, "");
	}, []);

	useEffect(() => {
		const cols = tableRef.current.querySelectorAll("th");
		cols.forEach((col) => {
			const resizer = document.createElement("div");
			resizer.className = "resizer";
			col.appendChild(resizer);

			let x = 0;
			let w = 0;

			const onMouseDown = (e) => {
				x = e.clientX;
				w = col.offsetWidth;

				document.addEventListener("mousemove", onMouseMove);
				document.addEventListener("mouseup", onMouseUp);
			};

			const onMouseMove = (e) => {
				const dx = e.clientX - x;
				col.style.width = `${w + dx}px`;
			};

			const onMouseUp = () => {
				document.removeEventListener("mousemove", onMouseMove);
				document.removeEventListener("mouseup", onMouseUp);
			};

			resizer.addEventListener("mousedown", onMouseDown);
		});
	}, []);

	return (
		<div className="">
			<table className="table table-bordered mb-1" ref={tableRef}>
				<thead className="tableHead1">
					<tr>
						{[
							"Action",
							"S.No",
							"Check in (group)",
							"Request for",
							"Re-order Level",
							"Re-order Qty",
							"Material Request Type",
							// <GetIcon iconName="PiSlidersHorizontalBold" size={12} />,
						].map((title, i) => {
							const isIcon = typeof title !== "string";
							const defaultWidths = {
								Action: "20px",
								"S.No": "20px",
								"Check in (group)": "220px",
								"Request for": "220px",
								"Re-order Level": "220px",
								"Re-order Qty": "220px",
								"Material Request Type": "220px",
								// Action1: "100px",
							};

							return (
								<th
									key={i}
									style={{
										fontSize: "7px",
										position: "relative",
										textAlign:
											title === "Action" ||
											title === "S.No" ||
											title === "isIcon"
												? "center"
												: "center",
										width:
											typeof title === "string"
												? defaultWidths[title] || "220px"
												: "220px",
										minWidth:
											typeof title === "string"
												? defaultWidths[title] || "220px"
												: "220px",
									}}
								>
									{title === "Action" ? (
										<input
											type="checkbox"
											className="form-check-input"
											style={{
												backgroundColor: isAllSelected ? "#270b79" : "",
												borderColor: isAllSelected ? "#270b79" : "",
												fontSize: "15px",
											}}
											checked={isAllSelected}
											onChange={handleSelectAll}
										/>
									) : isIcon ? (
										<div
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											{title}
										</div>
									) : (
										title
									)}
								</th>
							);
						})}
					</tr>
				</thead>

				<tbody>
					{currentRows.map((row, index) => {
						const globalIndex = indexOfFirstRow + index;
						return (
							<tr key={globalIndex}>
								<td className="p-0" style={{ cursor: "pointer" }}>
									<p
										className="m-0"
										style={{ position: "relative", top: "5px" }}
									>
										{selectedRows.includes(globalIndex) ? (
											<span onClick={() => toggleRowSelection(globalIndex)}>
												<input
													type="checkbox"
													className="form-check-input"
													style={{
														backgroundColor: "#270b79",
														fontSize: "15px",
														borderColor: "#270b79",
													}}
													checked
												/>
											</span>
										) : (
											<span onClick={() => toggleRowSelection(globalIndex)}>
												<input
													type="checkbox"
													className="form-check-input"
													style={{ fontSize: "15px" }}
												/>
											</span>
										)}
									</p>
								</td>
								<td
									style={{
										textAlign: "center",
										fontSize: "0.8rem",
										padding: "0.5rem",
									}}
								>
									{globalIndex + 1}
								</td>

								<td className="p-0">
									<SearchableDropdown
										globalIndex={globalIndex}
										field="warehouse_group"
										value={
											row.item?.warehouse_group || row.warehouse_group || ""
										}
										onChange={(val) =>
											updateRow(globalIndex, "warehouse_group", val)
										}
										onSearch={(text) => getwarehouse_data(0, text)}
										dropdownData={warehouse_list}
										placeholder="Select Warehouse Group"
										focusedCell={focusedCell}
										setFocusedCell={setFocusedCell}
										showDropdown={showDropdown}
										setShowDropdown={setShowDropdown}
										dropdownRef={dropdownRef1}
										setOffset={setOffset1}
										offset={offset1}
										search_input={search_input1}
										hasMore={hasMoreCategory}
										getData={getwarehouse_data}
										createNewUrl="/master/create-warehouse"
										createNewLabel="+ Create New Warehouse"
									/>
								</td>
								<td className="p-0">
									<SearchableDropdown
										globalIndex={globalIndex}
										field="warehouse"
										value={row.item?.warehouse || row.warehouse || ""}
										onChange={(val) => updateRow(globalIndex, "warehouse", val)}
										onSearch={(text) => getwarehouse_request_data(0, text)}
										dropdownData={warehouse_request_list}
										placeholder="Select Warehouse Request"
										focusedCell={focusedCell}
										setFocusedCell={setFocusedCell}
										showDropdown={showDropdown}
										setShowDropdown={setShowDropdown}
										dropdownRef={dropdownRef1}
										setOffset={setOffset1}
										offset={offset1}
										search_input={search_input1}
										hasMore={hasMoreCategory}
										getData={getwarehouse_request_data}
										createNewUrl="/master/create-warehouse"
										createNewLabel="+ Create New Warehouse"
									/>
								</td>
								<td
									className="p-0 d-flex justify-content-center"
									style={{
										border:
											focusedCell.rowIndex === globalIndex &&
											focusedCell.field === "warehouse_reorder_level"
												? "0.3px solid #270b79"
												: "",
									}}
								>
									<input
										type="text"
										placeholder="Re-order Level"
										onFocus={() =>
											setFocusedCell({
												rowIndex: globalIndex,
												field: "warehouse_reorder_level",
											})
										}
										onBlur={() =>
											setFocusedCell({ rowIndex: null, field: null })
										}
										className="form-control tableinput noborder"
										style={{ textAlign: "center", fontSize: "0.8rem" }}
										value={
											row?.item?.warehouse_reorder_level ||
											row.warehouse_reorder_level ||
											""
										}
										onChange={(e) =>
											updateRow(
												globalIndex,
												"warehouse_reorder_level",
												e.target.value
											)
										}
									/>
								</td>
								<td
									className="p-0"
									style={{
										border:
											focusedCell.rowIndex === globalIndex &&
											focusedCell.field === "warehouse_reorder_qty"
												? "0.3px solid #270b79"
												: "",
									}}
								>
									<input
										type="text"
										placeholder="Re-order Qty"
										onFocus={() =>
											setFocusedCell({
												rowIndex: globalIndex,
												field: "warehouse_reorder_qty",
											})
										}
										onBlur={() =>
											setFocusedCell({ rowIndex: null, field: null })
										}
										className="form-control tableinput noborder"
										style={{ textAlign: "center", fontSize: "0.8rem" }}
										value={
											row?.item?.warehouse_reorder_qty ||
											row.warehouse_reorder_qty ||
											""
										}
										onChange={(e) =>
											updateRow(
												globalIndex,
												"warehouse_reorder_qty",
												e.target.value
											)
										}
									/>
								</td>
								<td className="p-0">
									<SearchableDropdown
										globalIndex={globalIndex}
										field="material_request_type"
										value={
											row.item?.material_request_type ||
											row.material_request_type ||
											""
										}
										onChange={(val) =>
											updateRow(globalIndex, "material_request_type", val)
										}
										onSearch={(text) => getmaterial_request_type_list(0, text)}
										dropdownData={material_request_type_list}
										placeholder="Select Material Type"
										focusedCell={focusedCell}
										setFocusedCell={setFocusedCell}
										showDropdown={showDropdown}
										setShowDropdown={setShowDropdown}
										dropdownRef={dropdownRef1}
										setOffset={setOffset1}
										offset={offset1}
										search_input={search_input1}
										hasMore={hasMoreCategory}
										getData={getmaterial_request_type_list}
									/>
								</td>

								{/* <td
									style={{
										position: "relative",
										width: "40px",
									}}
								>
									<img
										src="/Maskgroup.png"
										alt="edit"
										style={{
											position: "absolute",
											top: "50%",
											left: "50%",
											transform: "translate(-50%, -50%)",
											width: "12px",
											height: "12px",
											pointerEvents: "none",
										}}
									/>
								</td> */}
							</tr>
						);
					})}
				</tbody>
			</table>

			<div
				className="d-flex pb-2  justify-content-between align-items-center"
				style={{ marginTop: "12px", marginBottom: "16px" }}
			>
				<div className="d-flex" style={{ gap: "4px" }}>
					{selectedRows.length > 0 && (
						<Button
							onClick={handleDeleteSelectedRows}
							className="customdeletebtn "
							iconName="MdDeleteOutline"
							iconSize={12}
						>
							Delete
						</Button>
					)}
					{selectedRows.length == 0 && (
						<Button
							onClick={handleAddRow}
							className="Addrowdesign"
							iconName="FiPlus"
							iconSize={12}
							iconWrapperStyle={{
								backgroundColor: "#ff8d5c",
								padding: "1px",
								display: "flex",
							}}
						>
							Add Row
						</Button>
					)}
				</div>

				<div
					className={`${
						rows3.length < 11 ? "d-none" : "d-flex"
					} align-items-center centerpagination`}
					style={{ gap: "5px" }}
				>
					<Pagination
						setCurrentPage={setCurrentPage}
						currentPage={currentPage}
						pageSize={rowsPerPage}
						totalrecords={rows3.length}
					/>
				</div>

				<div className={`${rows3.length < 11 ? "d-none" : "d-flex"}`}>
					<span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
						Showing {indexOfFirstRow + 1} to{" "}
						{Math.min(indexOfLastRow, rows3.length)} of {rows3.length} entries
					</span>
				</div>
			</div>
		</div>
	);
};

export default Tab2Table2;
